import React, { useRef, useState } from "react"
import Select from "react-select"
import { useTranslation } from "react-i18next"

export function PPDefaultSelector({
    id,
    name,
    data,
    placeholder,
    onChange,
    value,
    defaultValue,
    isMulti = false,
    isClearable = true,
    closeMenuOnSelect,
    blurInputOnSelect,
    components = null,
    noOptionsMessage,
    customStyles,
    isDisabled = false,
    menuInPortal = false
}) {
    const [t] = useTranslation()
    const [menuIsOpen, setMenuIsOpen] = useState(false)
    const ignoreNextCloseRef = useRef(false)

    if (placeholder == "") {
        placeholder = t("select") + "..."
    }

    let classname = ""
    if (isDisabled) {
        classname += "main-css-container-isdisabled"
    }

    // Only when explicitly closeMenuOnSelect={false} — do not change all isMulti selects.
    const keepMenuOpenOnSelect = closeMenuOnSelect === false
    const usePortal = menuInPortal || keepMenuOpenOnSelect
    const menuPortalTarget = usePortal && typeof document !== "undefined" ? document.body : null
    const mergedStyles = menuPortalTarget
        ? {
              ...(customStyles || {}),
              menuPortal: (base) => ({
                  ...base,
                  zIndex: 1060,
                  ...(typeof customStyles?.menuPortal === "function" ? customStyles.menuPortal(base) : {})
              })
          }
        : customStyles

    function handleChange(newValue, actionMeta) {
        if (
            keepMenuOpenOnSelect &&
            (actionMeta?.action === "select-option" || actionMeta?.action === "deselect-option")
        ) {
            ignoreNextCloseRef.current = true
            setMenuIsOpen(true)
            window.setTimeout(() => {
                ignoreNextCloseRef.current = false
            }, 150)
        }
        if (onChange) {
            onChange(newValue, actionMeta)
        }
    }

    function handleMenuClose() {
        if (ignoreNextCloseRef.current) {
            setMenuIsOpen(true)
            return
        }
        setMenuIsOpen(false)
    }

    return (
        <Select
            id={id}
            className={`pp-select ${classname}`.trim()}
            classNamePrefix="pp-select"
            name={name}
            options={data}
            styles={mergedStyles}
            placeholder={placeholder}
            onChange={handleChange}
            value={value}
            defaultValue={defaultValue}
            isMulti={isMulti}
            closeMenuOnSelect={closeMenuOnSelect ?? !isMulti}
            blurInputOnSelect={blurInputOnSelect ?? (keepMenuOpenOnSelect ? false : undefined)}
            menuIsOpen={keepMenuOpenOnSelect ? menuIsOpen : undefined}
            onMenuOpen={keepMenuOpenOnSelect ? () => setMenuIsOpen(true) : undefined}
            onMenuClose={keepMenuOpenOnSelect ? handleMenuClose : undefined}
            components={components}
            isClearable={isClearable}
            noOptionsMessage={noOptionsMessage}
            isDisabled={isDisabled}
            menuPortalTarget={menuPortalTarget}
            menuPosition={menuPortalTarget ? "fixed" : "absolute"}
        />
    )
}
